module.exports = __webpack_public_path__ + "img/3-6.cf9b6419.svg";